
function FormatPrice(price) {
    // Your formatting logic here
    // Example: Add comma separators for English digits
    if (price === null || price === undefined) return "";
    const priceString = price.toString();
    const formattedPrice = priceString.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    return formattedPrice;
}

export default FormatPrice;